'use client'

import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import paymentSuccess from '@/assets/imgs/invoices/paymentSuccess.png'
import Image from 'next/image'
import Link from 'next/link'

import Modal from'@/components/invoices/InvoicesModel'
export default function UserHintsHandler() {
    const [hint, setHint] = useState('')
    const[message, setMessage] = useState('')
    const [open, setOpen] = useState(false)
  useEffect(() => {
    const message = localStorage.getItem('welcomeMessage')

    if (message) {
    //   toast.success(message)
      setMessage(message)
      localStorage.removeItem('welcomeMessage')
      setOpen(true)
    }

    const walletHint = localStorage.getItem('showWalletHint')

    if (walletHint === '1') {
      const profile = JSON.parse(localStorage.getItem('profile') || '{}')

      if (profile?.wallet_hint) {
    setHint(profile.wallet_hint)
        
        setOpen(true)
      }

      localStorage.removeItem('showWalletHint')
    }
  }, [])
  function handleCloseBtn() {
    setOpen(false)
    // localStorage.removeItem('showWalletHint')
  }

  return (<>
  
  {open &&(
     <Modal
          onClick={() => {
            handleCloseBtn
          }}
          className='!p-4 '
        >
          <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M10.2857 1.28571C10.2857 0.944722 10.1503 0.617695 9.90914 0.376577C9.66802 0.135459 9.34099 0 9 0C8.65901 0 8.33198 0.135459 8.09086 0.376577C7.84974 0.617695 7.71429 0.944722 7.71429 1.28571V7.71429H1.28571C0.944722 7.71429 0.617695 7.84974 0.376577 8.09086C0.135459 8.33198 0 8.65901 0 9C0 9.34099 0.135459 9.66802 0.376577 9.90914C0.617695 10.1503 0.944722 10.2857 1.28571 10.2857H7.71429V16.7143C7.71429 17.0553 7.84974 17.3823 8.09086 17.6234C8.33198 17.8645 8.65901 18 9 18C9.34099 18 9.66802 17.8645 9.90914 17.6234C10.1503 17.3823 10.2857 17.0553 10.2857 16.7143V10.2857H16.7143C17.0553 10.2857 17.3823 10.1503 17.6234 9.90914C17.8645 9.66802 18 9.34099 18 9C18 8.65901 17.8645 8.33198 17.6234 8.09086C17.3823 7.84974 17.0553 7.71429 16.7143 7.71429H10.2857V1.28571Z'
              fill='white'
            />
          </svg>
          <div className='w-full flex flex-col justify-between items-center gap-[16px] md:gap-[32px]'>
            <Image
              src={paymentSuccess}
              width={100}
              height={100}
              alt='logo-success-payment'
              className='w-[50%] mb-[16px] md:mb-[32px] '
            />
          </div>
          <p className='text-[#D1D3D4] text-[24px] font-bold  mb-[16px] md:mb-[32px]'>
           تهانينا !
          </p>

            <p className='text-[#D1D3D4] text-[16px] md:text-[20px] font-bold  mb-[16px] md:mb-[32px]'>{message}</p>

          <button
            type='button'
            onClick={handleCloseBtn}
            className='cursor-pointer py-[14px] md:py-[19px] w-full bg-[#d9ac4f] text-[18px] text-[#D1D3D4] font-medium rounded-[14px] flex justify-center items-center gap-[15px]'
          >
            <p>استمرار</p>
          </button>
        </Modal>)}
  </>
  )
}